import DOMPurify from 'dompurify';

/** Authorable rich text may format content, but cannot introduce executable controls. */
export function sanitizeSurveyHtml(value: string): string {
  return DOMPurify.sanitize(value, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: [
      'style',
      'form',
      'input',
      'button',
      'textarea',
      'select',
      'iframe',
      'object',
      'embed',
    ],
  });
}

export function normalizeSurveyHtml(value: string) {
  return sanitizeSurveyHtml(value)
    .replace(/\r\n?/g, '\n')
    .replace(/\\n/g, '<br />')
    .replace(/(^|[\s>])\/n(?=$|[\s<])/g, '$1<br />')
    .replace(/\n/g, '<br />');
}

/** Plain text from the same normalized rich copy rendered by HtmlText. */
export function surveyHtmlText(value: string): string {
  return DOMPurify.sanitize(normalizeSurveyHtml(value), {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    RETURN_DOM_FRAGMENT: true,
  }).textContent?.trim() ?? '';
}
